import type { PartyRoleFormValues } from "@/components/Forms/PartyRoleForm.tsx";
import { Button, Grid2 as Grid, MenuItem, Paper, Stack, Typography } from "@mui/material";
import { RhfTextField } from "mui-rhf-integration";
import type { UseFormReturn } from "react-hook-form";

type Props = {
    form: UseFormReturn<PartyRoleFormValues>;
};

const PartyRoleInformation = ({ form }: Props) => {
    return (
        <Grid container>
            <Grid size={12}>
                <Paper
                    sx={{
                        mb: 2,
                        mx: 1,
                    }}
                >
                    <Grid
                        container
                        sx={{
                            borderRadius: "8px",
                            p: 1,
                        }}
                    >
                        <Grid size={12} sx={{ p: 1, mb: 1 }}>
                            <Stack
                                sx={{
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                }}
                            >
                                <Typography variant={"h5"}>Information</Typography>
                                {form.formState.isDirty && (
                                    <Button
                                        variant="contained"
                                        type={"submit"}
                                        sx={{
                                            p: 1,
                                            borderRadius: "8px",
                                            fontWeight: 800,
                                            mb: 2,
                                            mr: 2,
                                        }}
                                    >
                                        Save
                                    </Button>
                                )}
                            </Stack>
                        </Grid>
                        <Grid size={6} sx={{ p: 1 }}>
                            <RhfTextField
                                control={form.control}
                                name={"order"}
                                label={"Sort Order"}
                                sx={{
                                    width: "100%",
                                }}
                            />
                        </Grid>
                        <Grid size={6} sx={{ p: 1 }}>
                            <RhfTextField
                                control={form.control}
                                name={"partyRoleName"}
                                label={"Role Name"}
                                sx={{
                                    width: "100%",
                                }}
                            />
                        </Grid>
                        <Grid size={6} sx={{ p: 1 }}>
                            <RhfTextField
                                select
                                control={form.control}
                                name={"incomeOrExpense"}
                                label={"Role Purpose"}
                                sx={{
                                    width: "100%",
                                }}
                            >
                                <MenuItem key={"in-progress-blank"} value={""} />
                                <MenuItem key={"in-progress-yes"} value={"Income"}>
                                    Income
                                </MenuItem>
                                <MenuItem key={"in-progress-no"} value={"Expense"}>
                                    Expense
                                </MenuItem>
                            </RhfTextField>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        </Grid>
    );
};

export default PartyRoleInformation;
